export const BROWSING_HISTORY_STORAGE = 'browsingHistory';
export const GCLID = 'gclid';
export const ON_LOAD_URL = 'onLoadUrl';
export const SUPPLIER_PROFILE_VIEW = 'supplierProfileViewCount';
